import {formatUnits} from 'ethers';
import type {NearV1Portfolio} from '../../../../packages/sdk/src/near';

const amount=(raw:string,decimals:number)=>formatUnits(raw,decimals);
const quoteName=(id:string|null)=>id==='native:NEAR'?'NEAR':id??'unknown quote asset';

/** Read-only projection of the authenticated portfolio response. */
export function NearPortfolioAccounting({portfolio}:{portfolio:NearV1Portfolio}){
  const accounting=portfolio.accounting;
  const pending=portfolio.claimableRewards.filter(reward=>reward.claimAvailable===false);
  return <section className="near-portfolio-card" data-position="tokens" aria-label="Portfolio accounting">
    <h2>Cost basis and performance</h2>
    {!accounting?<p>Economic history is unavailable.</p>:<>
      <p>Final block {accounting.finalBlockHash} · observed {new Date(accounting.observedAtMs).toLocaleString()}</p>
      {accounting.positions.length?accounting.positions.map(position=>{
        const quote=quoteName(position.quoteAssetId),decimals=position.quoteDecimals;
        const money=(raw:string|null)=>raw===null||decimals===null?'Unavailable':`${amount(raw,decimals)} ${quote}`;
        return <div className="desk-position" key={position.assetId}>
          <strong>{position.assetId}</strong>
          <p>{amount(position.balanceRaw,position.assetDecimals)} units · {amount(position.knownUnitsRaw,position.assetDecimals)} with known basis · {amount(position.unknownUnitsRaw,position.assetDecimals)} with unknown basis</p>
          <dl>
            <div><dt>Remaining fee-inclusive basis</dt><dd>{decimals===null?'Unavailable':money(position.remainingBasisRaw)}</dd></div>
            <div><dt>Realized P&amp;L, known portion</dt><dd>{money(position.realizedKnownRaw)}</dd></div>
            <div><dt>Realized P&amp;L, total</dt><dd>{money(position.realizedTotalRaw)}</dd></div>
            <div><dt>Unrealized P&amp;L, known portion</dt><dd>{money(position.unrealizedKnownRaw)}</dd></div>
            <div><dt>Unrealized P&amp;L, total</dt><dd>{money(position.unrealizedTotalRaw)}</dd></div>
          </dl>
          <small>{position.valuationAtMs===null?'Current valuation unavailable':`Valuation observed ${new Date(position.valuationAtMs).toLocaleString()}`}</small>
        </div>;
      }):<p>No complete economic position history available.</p>}
      {accounting.unavailableAssets.length>0&&<div><h3>Assets awaiting complete history</h3>{accounting.unavailableAssets.map((asset,index)=><p key={`${asset.assetId}:${index}`}>{asset.assetId} · {asset.balanceRaw} raw units · {asset.reason}</p>)}</div>}
    </>}
    <h3>Rewards</h3>
    <p>Recorded pending automatic airdrops: {pending.length}. {pending.length>0&&pending.map(reward=>`${reward.raw} raw ${reward.kind} units for ${reward.launchId}`).join('; ')}</p>
    <p>Received reward history: Unavailable — this response does not supply verified delivery totals{accounting?.rewardCoverage==='complete'?'.':'; reward history coverage is incomplete.'}</p>
  </section>;
}
